<template>
  <el-row style="padding-bottom: 20px">
    <el-col :span="24" v-if="bannerList.length > 0">
      <el-carousel height="23rem">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <div
            class="background-image"
            :style="{
              background: 'url(' + imgserver + item.url + ')',
              '--bgImage': 'url(' + imgserver + VirtualImage + ')',
              backgroundSize: '100% 100%',
            }"
          ></div>
        </el-carousel-item>
      </el-carousel>
    </el-col>

    <!-- 面包屑及搜索栏 -->
    <el-col :span="24" class="breadcrumb-search">
      <!-- 面包屑 -->
      <div class="breadcrumb-block">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/' }"
            ><span>网站首页</span></el-breadcrumb-item
          >
          <el-breadcrumb-item><span>专业部系介绍</span></el-breadcrumb-item>
          <el-breadcrumb-item v-if="routerName">
            <span>{{ routerName }}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 搜索栏 -->
    </el-col>

    <el-col class="common-block page-content">
      <div class="asid-menu-block" v-if="!mobiePhoneShow">
        <el-menu :default-active="asidId" @select="clickAsidMenu">
          <div v-for="item in asidMenuList" :key="item.id">
            <el-menu-item class="asid-menu-item" :index="item.id.toString()">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>
      <div class="asid-hor-menu-block" v-if="mobiePhoneShow">
        <el-menu
          :default-active="asidId"
          class="el-menu-demo"
          mode="horizontal"
          @select="clickAsidMenu"
        >
          <div
            v-for="item in asidMenuList"
            :key="item.id"
            style="display: inline-block"
          >
            <el-menu-item class="asid-menu-item" :index="item.id.toString()">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>

      <!-- 内容 -->
      <div class="image-block">
        <div class="image-list">
          <div
            v-for="(item, index) in dataList"
            :key="item.id"
            class="image-item"
          >
            <div
              class="image-item-block cur-pointer"
              @click="toSubjectDetail(2, item, index)"
            >
              <img
                class="image-item-img"
                style="width: 100%"
                :src="imgserver + item.picUrl"
                alt=""
              />
              <div style="padding: 14px" class="image-item-text">
                <span>{{ item.title }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {
  getBannerListApi,
  getFunctionListApi,
  getHomeSubjectListApi,
} from "@/api/homeApi";
import shareMethods from "@/common/shareMethods";
export default {
  name: "home",
  components: {},
  data() {
    return {
      funcId: "26",
      asidId: "26",
      currentPage: 1,
      currentSize: 9,
      total: 0,
      searchValue: "",
      bannerList: [],
      dataList: [],
      asidMenuList: [],
      dataIndex: 0,
      routerName: "",
      tempDataList: [],
      initialindex: 0,
      // 获取当前轮播index + 已切换index = 即将切换的index
      tempIndex: 0,
      mobiePhoneShow: true,
    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = "https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = "长沙市唯上商务科技学校";
    let title = "长沙市唯上商务科技学校";
    this.share(imgUrl, linkUrl,desc, title );

    getBannerListApi(this.funcId).then((res) => {
      this.bannerList = res.data;
    });
    if (this.$route.query.id) {
      this.asidId = this.$route.query.id;
    }
    this.getFuncList();
    this.handleResize();
    var tmpList = window.location.href.split("id=");
    if (tmpList.length == 1) {
    } else {
      this.asidId = tmpList[1].split("&")[0];
    }
  },
  methods: {
    handlechange(index) {
      var length = this.dataList.length;
      // 大于4 循环播放
      if (length > 4) {
        this.tempDataList = this.dataList
          .concat(this.dataList)
          .slice(index, index + 4);
      } else {
        this.tempDataList = this.dataList;
      }
      this.tempIndex = index;
      this.initialindex = index;
    },
    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth < 768 ? true : false;
    },
    toSubjectDetail(type, item, index) {
      if (type == 1) {
        this.$router.push({
          path: "/subjectCenter",
        });
      } else if (type == 2) {
        item.funcId = 14;
        this.$router.push({
          path: "/studentAndJob",
          query: { id: item.funcId, type: 2, newsId: 27 },
        });
      }
    },

    getDataList(page, size, funcId, searchValue) {
      getHomeSubjectListApi(this.currentPage, this.currentSize).then((res) => {
        this.dataList = res.rows;
        this.total = res.total;
      });
    },
    getFuncList() {
      var tmpasidId = this.asidId;
      getFunctionListApi((this.funcId = 24)).then((res) => {
        if (res.data.length > 0) {
          this.asidMenuList = res.data;
          var tmprouterName = res.data[0].name;
          this.asidMenuList.forEach((item, index) => {
            if (item.id == tmpasidId) {
              tmprouterName = item.name;
            }
          });
          this.routerName = tmprouterName;
          this.asidId = (tmpasidId ? tmpasidId : res.data[0].id).toString();
          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        } else {
          this.asidId = this.funcId.toString();
          this.asidMenuList[0] = { name: "专业部系介绍", id: 26 };
          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        }
      });
    },
    handleToggleImage(index) {
      var dataLength = this.dataList.length;
      var toggleIndex = 0;
      if (this.tempIndex + index > dataLength) {
        toggleIndex = this.tempIndex + index - dataLength;
      } else {
        toggleIndex = index;
      }
      this.$refs.carouse.setActiveItem(toggleIndex);
    },
    clickAsidMenu(index) {
      this.openType = 0;
      this.searchValue = "";
      this.$router.push({
        path: "/honorCenter",
        query: { id: index, time: new Date().getTime() },
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.asidId = to.query.id;
    this.getFuncList();
    next((vm) => {});
  },
  computed: {},
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.background-image {
  min-width: 120rem; /* 设置div的宽度 */
  margin: 0 12rem;
  height: 100%; /* 设置div的高度 */
  background-clip: content-box;
  background-repeat: no-repeat;
  background-position: center; /* 背景图片居中 */
  color: #fff;
  background-size: 100% 100%;
}
::v-deep .el-carousel__indicators {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

::v-deep .el-carousel__indicators {
}

.banner-block {
  display: flex;
  flex-direction: column;
  .carousel_title {
    margin: 85px 0 0 38px;
    font-size: 40px;
    min-height: 52px;
    width: 90vw;
    line-height: normal;
    font-weight: 700;
  }
  .carousel_description {
    margin: 6px 0 0 38px;
    font-size: 18px;
    width: 90vw;
    line-height: normal;
    min-height: 52px;
    font-weight: 400;
  }
  .carousel_button {
    margin: 22px 0 0 38px;
    font-size: 14px;
    width: 90vw;
    min-height: 52px;
    font-weight: 400;
  }
}

.background-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背景下 */
}

.breadcrumb-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120rem;
  margin: 20px 12rem 20px 12rem;
  .breadcrumb-block {
    width: 280px;
    margin-left: 22rem;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    .el-breadcrumb {
      height: 20px;
      span {
        font-size: 14px;
        width: 85px;
        height: 20px;
        color: #0e517a;
        line-height: 20px;
      }
    }
  }
  .search-block {
    margin-right: 16rem;
    width: 290px;
    height: 32px;
    .search-input {
      margin-top: -4px;
      .el-input__inner {
      }
      .serach-button {
        background-color: #255077;
        height: 100%;
      }
    }
  }
}
.page-content {
  display: flex;
  flex-direction: row;
  width: 120rem;
  .asid-menu-block {
    width: 20rem;
    border-bottom: 0px;
    margin-bottom: 20px;
    ul {
      border-left: 2px solid #255077;
      border-right: 0;
      .el-menu-item {
        font-weight: 400;
        font-size: 20px !important;
        color: #6f7288 !important;
      }
      .is-active {
        background-color: #fff !important;
        color: #255077 !important;
        border-top: 2px solid #f9f9fa;
        border-left: 2px solid #f9f9fa;
        border-bottom: 2px solid #f9f9fa;
        font-weight: bolder !important;
        position: relative;
        &::after {
          width: 6px;
          height: 6px;
          border-top: 2px solid;
          border-right: 2px solid;
          border-color: #255077;
          content: "";
          position: absolute;
          left: 120px;
          top: 26px;
          transform: rotate(45deg);
        }
      }
    }
  }
  .asid-hor-menu-block {
    margin-bottom: 20px;
    width: 128rem;
    .el-menu--horizontal {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      div {
        width: 40rem;
        .el-menu-item {
          font-size: 13px !important;
          font-weight: 400;
          color: #74727d;
          text-align: center;
        }
        .is-active {
          background-color: #fff !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          border-bottom: 2px solid #2e4d75;
          span {
            color: #255077 !important;
          }
          :hover {
            span {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}

.image-block {
  display: flex;
  flex-direction: column;
  width: 100.5rem;
  justify-content: center;
  align-items: center;
  .image-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100.5rem;
    justify-content: start;
    .image-item {
      width: 31.5rem;
      margin-left: 2rem;
      height: 245px;
      margin-bottom: 30px;
      background-color: #f7f7f7;
      .image-item-block {
        display: flex;
        flex-direction: column;
        .image-item-img {
          width: 100%;
          height: 195px;
        }
        .image-item-text {
          font-weight: 500;
          text-align: center;
          font-size: 16px;
        }
      }
    }
  }
  .image-detail-block {
    width: 100.5rem;
    .image-detail-carousel {
      width: 100%;
      margin-bottom: 40px;
      background-color: #fff;
      .image-detail-carousel-item {
        .image-carousel-item-icon {
          height: 58rem;
        }
        .image-carousel-item-title {
          text-align: center;
          height: 50px;
          z-index: 999;
          line-height: 50px;
          font-size: 20px;
          margin-top: 20px;
        }
      }
    }
    .carousel-sublist {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      height: 240px;
      .carousel-sublist-item {
        display: flex;
        flex-direction: column;
        justify-content: start;
        margin-right: 10px;
        .sublist-item-block {
          width: 24rem;
          height: 240px;
          flex-direction: column;
          justify-content: start;
          align-content: center;
          align-items: center;
          &:last-child {
            margin-right: 0;
          }
          .sublist-item-icon {
            width: 100%;
            height: 195px;
          }
          .sublist-item-title {
            text-align: center;
            height: 20px;
            z-index: 999;
            line-height: 20px;
            font-size: 16px;
          }
        }
      }
    }
  }
}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1439px) {
  .background-image {
    width: 100%;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 0 auto;
    height: 100%; /* 设置div的高度 */
  }

  .contain-block {
    width: 120rem;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 40px 12rem 0 0;
  }
}
@media only screen and (max-width: 1330px) {
}
@media only screen and (max-width: 1200px) {
}
@media only screen and (max-width: 992px) {
  .breadcrumb-search {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    .breadcrumb-block {
      width: 280px;
      font-weight: 400;
      display: flex;
      margin-left: 0;
      flex-direction: row;
      .el-breadcrumb {
        span {
          font-size: 14px;
          width: 85px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }
    }
    .search-block {
      width: 120rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      div {
        width: 290px;
        height: 32px;
        .search-input {
          .serach-button {
            background-color: #255077;
            height: 100%;
          }
        }
      }
    }
  }

  .common-block {
    margin: 0 12rem;
    width: 120rem;
  }
  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          font-weight: 400;
          font-size: 12px !important;
          color: #6f7288 !important;
          position: relative;
        }
        .is-active {
          &::after {
            left: 70px;
          }
        }
      }
    }
  }
  .common-block {
    margin: 0;
  }
  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          font-weight: 400;
          font-size: 12px !important;
          color: #6f7288 !important;
          position: relative;
          &::after {
            display: none;
          }
        }
      }
    }
  }

  .image-block {
    width: 100.5rem;
    .image-list {
      width: 100.5rem;
      .image-item {
        width: 48rem;
        .image-item-block {
          .image-item-img {
            width: 100%;
            height: 195px;
          }
          .image-item-text {
            font-weight: 500;
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }
    .image-detail-block {
      width: 100.5rem;
      .image-detail-carousel {
        width: 100%;
        margin-bottom: 40px;
        .image-detail-carousel-item {
        }
      }
      .carousel-sublist {
        height: 240px;
        .carousel-sublist-item {
          margin-right: 10px;
          .sublist-item-block {
            width: 24rem;
            height: 220px;
            &:last-child {
              margin-right: 0;
            }
            .sublist-item-icon {
              width: 100%;
              height: 165px;
            }
            .sublist-item-title {
              text-align: center;
              height: 20px;
              z-index: 999;
              line-height: 20px;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }

  .page-content {
    width: 144rem;
    flex-direction: column;
    .asid-menu-block {
      width: 90px;
    }

    .image-block {
      width: 128rem;
      .image-list {
        width: 100%;
        .image-item {
          width: 100%;
          margin-left: 0rem;
          height: 265px;
          .image-item-block {
            .image-item-img {
              width: 100%;
              height: 225px;
            }
            .image-item-text {
              font-weight: 500;
              text-align: center;
              font-size: 16px;
            }
          }
        }
      }
      .image-detail-block {
        width: 100%;
        .image-detail-carousel {
          width: 100%;
          margin-bottom: 40px;
          background-color: #fff;
          .image-detail-carousel-item {
            .image-carousel-item-title {
              text-align: center;
              height: 50px;
              z-index: 999;
              line-height: 50px;
              font-size: 20px;
              margin-top: 20px;
            }
          }
        }
        .carousel-sublist {
          height: 120px;
          flex-direction: row;
          flex-wrap: wrap;
          .carousel-sublist-item {
            width: 44rem;
            margin-right: 10px;
            box-sizing: border-box;
            .sublist-item-block {
              height: 120px;
              width: 44rem;
              &:last-child {
                margin-right: 0;
              }
              .sublist-item-icon {
                width: 100%;
                height: 80px;
              }
              .sublist-item-title {
                text-align: center;
                height: 20px;
                z-index: 999;
                line-height: 20px;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
  .common-block {
    width: 128rem;
    margin: 0 8rem;
    padding-left: 0;
  }
}
@media only screen and (max-width: 520px) {
  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .is-active {
          &::after {
            left: 80px;
          }
        }
      }
    }
  }
}
</style>
